import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroCarousel from "./components/HeroCarousel";
import CategorySection from "./components/CategorySection";
import LatestUpdates from "./components/LatestUpdates";
import HotRecommend from "./components/HotRecommend";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <HeroCarousel />
        <CategorySection />
        <LatestUpdates />
        <HotRecommend />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}